import React from 'react'
import styles from './container.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'

const Container = ({
  classes,
  img,
  primary,
  secondary,
  children,
  success,
  noHead,
  neutral,
  imgClassName
}) => (
  <div
    className={classNames(classes.container, {
      [classes.primary]: primary,
      [classes.secondary]: secondary,
      [classes.neutral]: neutral
    })}>
    {!noHead && (
      <div className={classes.head}>
        <div
          className={classNames(classes.imgHolder, imgClassName)}
          style={{ backgroundImage: `url(${img})` }}
        />
      </div>
    )}
    {children}
  </div>
)

export default injectSheet(styles)(Container)
